import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { CIVILISATION_LIST } from '../../app/constants'

const Nav = ({ isToggled }) => {
  const params = useLocation()
  const currentPage = params.pathname

  const [hoveredItem, setHoveredItem] = useState()

  const pages = [
    { name: 'My Stats', path: '/my-stats', dropDown: true },
    {
      name: 'Collection',
      path: '/collection',
      dropDown: true,
    },
    { name: 'Map', path: '/', inactive: true },
    { name: 'Missions', path: '/missions', dropDown: true },
    { name: 'Governance', path: '/', inactive: true },
    { name: 'Leaderboard', path: '/leaderboard', dropDown: true },
    { name: 'Fusion', path: '/', inactive: true },
    { name: 'Shop', path: '/shop' },
    {
      name: 'Logout',
      path: false,
      click: () => {
        console.log(true)
        localStorage.clear()
        window.location.reload()
      },
    },
  ]

  return (
    <React.Fragment>
      <nav
        style={isToggled ? { display: 'flex' } : { display: 'none' }}
        className="text-white lg:hidden flex py-8 bg-black h-screen w-screen inset-0 absolute z-40 pt-28 justify-center overflow-auto"
      >
        <div
          className={
            isToggled ? 'w-4/5 nav__wrapper active' : 'w-4/5 nav__wrapper'
          }
        >
          <p className="uppercase text-gold">Main Menu</p>
          <ul className="w-full flex flex-col justify-between">
            {pages.map((page, i) => {
              return page.inactive ? (
                <li
                  key={page.name}
                  className="drop-shadow-md opacity-60 cursor-default  border-t border-t-gold py-2"
                >
                  {page.name}
                </li>
              ) : page.path ? (
                <div key={page.name} className="relative">
                  <Link
                    style={
                      currentPage.includes(page.path)
                        ? { color: '#00FFF0' }
                        : {}
                    }
                    className="drop-shadow-md hover:text-cyanBlue py-1.5 border-t border-t-gold block "
                    to={page.path}
                    onMouseEnter={() => setHoveredItem(page.name)}
                    onMouseLeave={() => setHoveredItem('')}
                  >
                    {page.name}
                  </Link>
                  {page.dropDown && (
                    <ul key={i} className="flex flex-col font-jura w-full ">
                      {CIVILISATION_LIST.slice(
                        0,
                        !(page.name === 'Collection')
                          ? -1
                          : CIVILISATION_LIST.length,
                      ).map((civilisation, n) => {
                        return (
                          <Link
                            key={n}
                            className="hover:text-cyanBlue border-t border-t-gold py-1.5 pl-5 "
                            to={`${page.path}/${civilisation.toLowerCase()}`}
                          >
                            {civilisation}
                          </Link>
                        )
                      })}
                    </ul>
                  )}
                </div>
              ) : (
                <div key={page.name} className="relative">
                  <div
                    className="drop-shadow-md hover:text-cyanBlue py-1.5 border-t border-t-gold block"
                    onClick={() => page.click()}
                  >
                    {page.name}
                  </div>
                </div>
              )
            })}
          </ul>
        </div>
      </nav>
      <nav className="text-white hidden lg:block nav-bar--desktop -mt-4 2xl:mt-0 py-4 xl:py-8 3xl:py-12 px-8 xl:px-14 font-ethnocentric xl:mb-2 3xl:mb-10">
        <ul className="w-full flex justify-between">
          {pages.map((page, i) => {
            return page.inactive ? (
              <li key={i} className="drop-shadow-md opacity-60 cursor-default">
                {page.name}
              </li>
            ) : page.path ? (
              <div key={page.name} className="relative">
                <Link
                  style={
                    currentPage.includes(page.path) ? { color: '#00FFF0' } : {}
                  }
                  className="drop-shadow-md hover:text-cyanBlue py-7"
                  to={page.path}
                  onMouseEnter={() => setHoveredItem(page.name)}
                  onMouseLeave={() => setHoveredItem('')}
                >
                  {page.name}
                </Link>
                {page.dropDown && (
                  <ul
                    key={i}
                    onMouseEnter={() => setHoveredItem(page.name)}
                    onMouseLeave={() => setHoveredItem('')}
                    style={
                      hoveredItem === page.name
                        ? { opacity: '1', display: 'flex' }
                        : { opacity: '0', display: 'none' }
                    }
                    className="flex flex-col font-jura absolute bg-black w-full min-w-[165px] top-8 z-50"
                  >
                    {CIVILISATION_LIST.slice(
                      0,
                      !(page.name === 'Collection')
                        ? -1
                        : CIVILISATION_LIST.length,
                    ).map((civilisation, n) => {
                      return (
                        <Link
                          key={n}
                          className="hover:text-cyanBlue border-t border-t-gold mx-3 py-2 pl-1 first:border-t-0"
                          to={`${page.path}/${civilisation.toLowerCase()}`}
                        >
                          {civilisation}
                        </Link>
                      )
                    })}
                  </ul>
                )}
              </div>
            ) : (
              <div key={page.name} className="relative">
                <Link
                  style={page.path === currentPage ? { color: '#00FFF0' } : {}}
                  className="drop-shadow-md hover:text-cyanBlue py-7"
                  to={page.path}
                  onClick={() => page.click()}
                >
                  {page.name}
                </Link>
              </div>
            )
          })}
        </ul>
      </nav>
    </React.Fragment>
  )
}

export default Nav
